exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clear-icon[data-v-3a9fe814] {\n    position:absolute;\n    top: 5px;\n    right: 5px\n}\n", ""]);

// exports
